import { render, staticRenderFns } from "./ProgramQuestions.vue?vue&type=template&id=ba759b08&scoped=true&"
import script from "./ProgramQuestions.vue?vue&type=script&lang=js&"
export * from "./ProgramQuestions.vue?vue&type=script&lang=js&"
import style0 from "./ProgramQuestions.vue?vue&type=style&index=0&id=ba759b08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba759b08",
  null
  
)

export default component.exports